import type { ChatMessageView } from '@/hooks/useFirestoreP2PChat';
import type { P2PThreadMeta } from '@/services/chatMessagesFirestore';
import { isOptimisticOutgoingChatBubble } from '@/utils/chatOptimisticDisplayMessages';

export type ChatOutboundReceiptTicksStatus = 'none' | 'pending' | 'sent' | 'read';

/** Макс. client-ts сообщений, который собеседник отметил прочитанным (readThroughTs для его токена). */
export function computePeerReadThroughMessageTs(
  meta: Pick<P2PThreadMeta, 'readThroughTs0' | 'readThroughTs1'> | null | undefined,
  myInviteToken: string,
  peerInviteToken: string
): number {
  if (!meta) return 0;
  const s = [myInviteToken, peerInviteToken].sort() as [string, string];
  if (myInviteToken === s[0]) {
    return typeof meta.readThroughTs1 === 'number' && Number.isFinite(meta.readThroughTs1)
      ? meta.readThroughTs1
      : 0;
  }
  return typeof meta.readThroughTs0 === 'number' && Number.isFinite(meta.readThroughTs0)
    ? meta.readThroughTs0
    : 0;
}

/** Макс. client-ts сообщений, которые текущий участник отметил прочитанным (своё поле readThroughTs). */
export function computeMyReadThroughMessageTs(
  meta: Pick<P2PThreadMeta, 'readThroughTs0' | 'readThroughTs1'> | null | undefined,
  myInviteToken: string,
  peerInviteToken: string
): number {
  if (!meta) return 0;
  const s = [myInviteToken, peerInviteToken].sort() as [string, string];
  if (myInviteToken === s[0]) {
    return typeof meta.readThroughTs0 === 'number' && Number.isFinite(meta.readThroughTs0)
      ? meta.readThroughTs0
      : 0;
  }
  return typeof meta.readThroughTs1 === 'number' && Number.isFinite(meta.readThroughTs1)
    ? meta.readThroughTs1
    : 0;
}

export function outboundReceiptStatusForMessage(
  m: ChatMessageView,
  opts: { cloudLike: boolean; peerReadThroughMessageTs: number }
): ChatOutboundReceiptTicksStatus {
  if (!m.isSelf) return 'none';
  if (!opts.cloudLike) return 'sent';
  if (isOptimisticOutgoingChatBubble(m)) {
    const uploading = m.attachments?.some((a) => a.uploadStatus === 'uploading');
    return uploading ? 'pending' : 'sent';
  }
  const peerTs = opts.peerReadThroughMessageTs;
  if (peerTs > 0 && peerTs + 2 >= m.ts) return 'read';
  return 'sent';
}
